import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ProfileData = Record<string, any>;

type ProfileState = {
  value: ProfileData | null;
};

const initialState: ProfileState = {
  value: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile(state, action: PayloadAction<ProfileData>) {
      state.value = action.payload;
    },
  },
});

export const { setProfile } = profileSlice.actions;
